
import { Component, Inject, ViewChild, ElementRef, OnInit } from '@angular/core';

import { Store } from '@src/store';
import { cmsActions } from '@src/store/reducers/cmsReducer';
import { DialogManagerService } from '@src/services';
import { AddOrEditActivityComponent } from '@app/shared/components/dialogs/add-or-edit-activity-dialog/add-or-edit-activity-dialog.component'
import * as _str from 'underscore.string';
import { MatSort, MatTable, MatTableDataSource } from '@angular/material';


export interface JiraCmsTable {
  Id: string;
  Name: string;
  Text: string;
}

@Component({
  selector: 'cms-tasks',
  template: require('./cms-tasks.component.html'),
  styles: [require('./cms-tasks.component.scss')]
})

export class CmsTasksComponent implements OnInit {
  public projectId: number;
  public unsubscribe: any;
  public filter: string;
  public tempCMS: any;
  public selectedActivity: any;
  public tasks: any;
  public filterDataTasks: any[];
  public displayedColumns = ['Id', 'Name', 'Text', 'creationDate', 'Actions'];
  @ViewChild(MatSort) public sort: MatSort;
  public dataSource;

  @ViewChild(MatTable, { read: ElementRef }) private;



  constructor(private store: Store, @Inject('$stateParams') $stateParams: any, private dialogManagerService: DialogManagerService) {
    this.dataSource = new MatTableDataSource<JiraCmsTable>([]);
    this.projectId = $stateParams.id

  }


  public ngOnInit() {
    this.getQueriesFromApi()
  }

  public ngOnDestroy() {
    this.unsubscribe();
  }

  getQueriesFromApi() {

    this.unsubscribe = this.store.subscribe(() => {
      const data = [];
      if (this.store.getState().cmss.tasks) {
        this.tasks = this.store.getState().cmss.tasks;
        this.tasks.forEach((item) => {

          item.tagsNames = item.tags ? item.tags.map(m => m.displayName).join(', ') : '';
          data.push({
            id: item.id,
            creationDate: item.creationDate,
            name: item.name,
            text: item.description
          });
        })
        this.dataSource.data = data;
        this.filterDataTasks = data
        if (this.dataSource.data.length > 0) {
          this.unsubscribe();
        }
      }

    })
    this.store.dispatch({ type: cmsActions.GET_ALL_TASKS, payload: { projectId: this.projectId } });
  }




  addOrEditActivity(edit, index) {

    const onConfirm = (data) => {
      const projectId = this.projectId;
      this.selectedActivity = this.tempCMS;
      if (edit) {
        const type = cmsActions.UPDATE_TASK
        this.store.dispatch({
          type: type,
          payload: {
            data: {
              id: data.activity.id,
              name: data.activity.name,
              description: (data.activity.text) ? data.activity.text : '',
              creationDate: "30/07/2017 15:05",
              index: index,
              projectId: projectId
            }
          }
        }).then(res => {
          if (res) {
            this.getQueriesFromApi()
          }
        });
      }
      else {
        this.store.dispatch({
          type: cmsActions.ADD_TASK,
          payload: {
            data: {
              id: -1,
              name: data.activity.name,
              description: (data.activity.text) ? data.activity.text : '',
              creationDate: "30/07/2017 15:05",
              projectId: projectId
            }
          },
          callback: () => { }
        }).then(res => {
          if (res) {
            this.getQueriesFromApi()
          }
        })
      }
    }

    this.tempCMS = Object.assign({}, this.selectedActivity);
    const dialogData = {
      title: (edit) ? 'Edit Activity' : 'Add New Activity',
      name: 'Activity',
      text: 'Description Name',
      activity: (edit) ? this.tempCMS : {},
      projectId: this.projectId,
      store: this.store
    };
    this.dialogManagerService.showDialog(dialogData, onConfirm, AddOrEditActivityComponent, 'add-or-edit-activity-dialog');

  }

  onEditActivity(item, index) {
    this.selectedActivity = item.data;
    this.addOrEditActivity(true, index);
  }

  onRemoveActivity(item) {
    this.selectedActivity = item.data;
    const onConfirm = () => {
      this.store.dispatch({ type: cmsActions.DELETE_TASK, payload: { taskId: this.selectedActivity.id } }).then(data => {
        if (data) {
          this.getQueriesFromApi()
        }
      });
    };
    const dialogData = { title: 'Delete Activity', action: 'delete', objectType: 'activity', item: item.data.name };
    this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
  }



  filterData(filter) {
    let countEmptyArray = 0
    if (!filter) {
      this.dataSource.data = this.filterDataTasks
    }
    for (const property of Object.keys(this.filterDataTasks[0])) {
      let res = this.filterDataTasks.filter(x => String(x[property]).includes(filter));
      if (res.length == 0) {
        countEmptyArray++
      }
      if (Object.keys(this.filterDataTasks[0]).length == countEmptyArray) {
        this.dataSource.data = []
      }
      if (res.length > 0) {
        this.dataSource.data = res
      }

    }

  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/taskManager-ang7/CmsTasks/cms-tasks.component.ts